<!-- 公司介绍 -->
<template>
  <div class="introduce">
    <p class="title">北京发现角科技有限公司</p>
    <p class="content">北京发现角科技有限公司，成立于2011年2月，公司员工40多人。公司管理团队由来自各大互联网公司的精英组成。 公司在情侣细分市场已有7年的经验，致力于情侣手机移动应用和游戏的研发运营。</p>
    <p class="content">公司希望把情侣游戏做成极致、创新、直指人心的产品，并做到细分市场压倒性领先位置。</p>
  </div>
</template>

<script>
export default {
  name: "Introduce",
  data() {
    return {};
  },
  created() {
    this.$store.dispatch("initTabName", "about");
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.introduce {
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  margin-bottom: 150px;
}

.title {
  text-align: center;
  width: 100%;
  font-size: 20px;
  color: #e1556d;
  margin-top: 80px;
}

.content {
  font-size: 18px;
  color: #303032;
  line-height: 34px;
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/Introduce.vue